import AddStoreContainer from '@components/addStore/AddStoreContainer';
import {
  assignGroupManager,
  assignGroupManagers,
  assignStoresToGroup,
  unassignStoresFromGroup,
  getStoreAdminAccess,
  createStoreGroup,
  deleteStoreGroup,
  renameStoreGroup,
  getDeviceExcelLogs,
  getStoreAdminDetail,
  getStoreAdminPermissions,
  getStoreAdminStores,
  getStoreGroups,
  searchMasterUsers,
  moveStoreDevices,
  patchBusinessNum,
  patchStoreName,
  previewDeviceExcel,
  resetStorePassword,
  saveDeviceExcel,
  saveStoreAdminPermission,
} from '@apis/storeAdmin';
import StorePickButton from '@components/common/StorePickButton';
import { Button, Form, Modal } from 'react-bootstrap';
import { IoMdArrowBack } from 'react-icons/io';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

type Tab = 'list' | 'register' | 'grant' | 'group';
type RegisterSub = 'single' | 'bulk';
const StoreManagement = () => {
  const navigation = useNavigate();
  const [tab, setTab] = useState<Tab>('list');
  const [registerSub, setRegisterSub] = useState<RegisterSub>('single');
  const [openGroupId, setOpenGroupId] = useState<number | null>(null);
  const [renameId, setRenameId] = useState<number | null>(null);
  const [renameName, setRenameName] = useState('');
  const [keyword, setKeyword] = useState('');
  const [stores, setStores] = useState<any[]>([]);
  const [detail, setDetail] = useState<any>(null);
  const [name, setName] = useState('');
  const [biz, setBiz] = useState('');
  const [targetStore, setTargetStore] = useState('');
  const [picked, setPicked] = useState<number[]>([]);
  const [resetInfo, setResetInfo] = useState<{ loginId: string; tempPassword: string } | null>(
    null,
  );
  const [resetTarget, setResetTarget] = useState<{
    userId: number;
    loginId: string;
    name: string;
  } | null>(null);
  const [message, setMessage] = useState('');
  const [file, setFile] = useState<File | null>(null);
  const [preview, setPreview] = useState<any[]>([]);
  const [logs, setLogs] = useState<any[]>([]);
  const [permissions, setPermissions] = useState<any[]>([]);
  const [grantId, setGrantId] = useState('');
  const [perm, setPerm] = useState({ canRead: true, canUpdate: false, canDelete: false });
  const [groupName, setGroupName] = useState('');
  const [managerId, setManagerId] = useState('');
  const [groupStores, setGroupStores] = useState('');
  const [groupSearch, setGroupSearch] = useState('');
  const [managerLogins, setManagerLogins] = useState('');
  const [members, setMembers] = useState<any[]>([]);
  const [memberQuery, setMemberQuery] = useState('');
  const [pickedMembers, setPickedMembers] = useState<string[]>([]);
  const [groups, setGroups] = useState<any[]>([]);
  const [checkedStores, setCheckedStores] = useState<number[]>([]);
  const [moveGroupId, setMoveGroupId] = useState('');
  const [groupFilter, setGroupFilter] = useState('all');
  const [isMaster, setIsMaster] = useState(false);
  const [managerGroupId, setManagerGroupId] = useState('');

  const loadStores = async (word = keyword) => {
    setStores(await getStoreAdminStores(word));
  };

  useEffect(() => {
    loadStores('').catch((error) => setMessage(error?.response?.data?.message || '목록 조회 실패'));
    getStoreGroups()
      .then(setGroups)
      .catch(() => setGroups([]));
    getStoreAdminAccess()
      .then((access) => setIsMaster(!!access?.master))
      .catch(() => setIsMaster(false));
  }, []);

  useEffect(() => {
    if (tab !== 'group' || openGroupId == null) return;
    searchMasterUsers(memberQuery.trim())
      .then((rows) =>
        setMembers(
          (Array.isArray(rows) ? rows : []).filter(
            (row) => String(row.authority || '') !== 'ROLE_MASTER',
          ),
        ),
      )
      .catch((error) => setMessage(error?.response?.data?.message || '회원 목록 조회 실패'));
  }, [tab, openGroupId, memberQuery]);

  useEffect(() => {
    if (tab !== 'register' || registerSub !== 'bulk') return;
    getDeviceExcelLogs()
      .then(setLogs)
      .catch((error) => setMessage(error?.response?.data?.message || '등록 기록 조회 실패'));
  }, [tab, registerSub]);

  const openStore = async (storeId: number) => {
    const data = await getStoreAdminDetail(storeId);
    setDetail(data);
    setName(data.store.storeName || '');
    setBiz(data.store.businessNum || '');
    setPicked([]);
    setTab('list');
  };

  const storeIdSet = (raw: string) =>
    new Set(
      String(raw || '')
        .split(',')
        .map((id) => Number(id.trim()))
        .filter(Boolean),
    );

  const groupedStoreIds = new Set(
    groups.flatMap((group) => Array.from(storeIdSet(group.storeIds))),
  );

  const assignStores = stores.filter((store) => {
    const word = keyword.trim();
    if (word && !`${store.storeId} ${store.storeName || ''}`.includes(word)) return false;
    if (moveGroupId === 'none') return !groupedStoreIds.has(store.storeId);
    return true;
  });

  const visibleStores = stores.filter((store) => {
    if (groupFilter === 'all') return true;
    if (groupFilter === 'none') return !groupedStoreIds.has(store.storeId);
    const group = groups.find((item) => String(item.groupId) === groupFilter);
    return group ? storeIdSet(group.storeIds).has(store.storeId) : false;
  });

  const err = (error: any, fallback: string) =>
    setMessage(error?.response?.data?.message || error?.message || fallback);

  return (
    <div className="add_store_wrapper store_admin">
      <div className="notice_tabs" role="tablist">
        <button
          type="button"
          className="tab_back"
          aria-label="뒤로가기"
          onClick={() => navigation(-1)}
        >
          <IoMdArrowBack size="1.4rem" />
        </button>
        <button
          type="button"
          className={tab === 'list' ? 'active' : ''}
          onClick={() => setTab('list')}
        >
          상점 목록
        </button>
        <button
          type="button"
          className={tab === 'register' ? 'active' : ''}
          onClick={() => setTab('register')}
        >
          상점등록
        </button>
        <button
          type="button"
          title="그룹관리에서 그룹 등록가능"
          className={tab === 'group' ? 'active' : ''}
          onClick={async () => {
            setTab('group');
            setGroups(await getStoreGroups());
          }}
        >
          그룹관리
        </button>
      </div>
      {tab === 'register' && (
        <div className="sub_tabs" role="tablist">
          <button
            type="button"
            className={registerSub === 'single' ? 'active' : ''}
            onClick={() => setRegisterSub('single')}
          >
            개별 등록
          </button>
          <button
            type="button"
            className={registerSub === 'bulk' ? 'active' : ''}
            onClick={() => setRegisterSub('bulk')}
          >
            일괄등록
          </button>
        </div>
      )}
      {message && <p className="info_text">{message}</p>}

      {tab === 'register' && registerSub === 'single' && <AddStoreContainer />}

      {tab === 'list' && !detail && (
        <>
          <div className="list_tools">
            <Form.Control
              value={groupSearch}
              placeholder="그룹 검색"
              onChange={(e) => setGroupSearch(e.target.value)}
            />
            <Form.Select
              value={groupFilter}
              onChange={(e) => setGroupFilter(e.target.value)}
              aria-label="그룹 필터"
            >
              <option value="all">전체</option>
              {groups.map((group) => (
                <option key={group.groupId} value={group.groupId}>
                  {group.groupName}
                </option>
              ))}
              {isMaster && <option value="none">그룹 없음</option>}
            </Form.Select>
            <Form.Control
              value={keyword}
              placeholder="지점코드 또는 지점명"
              onChange={(e) => setKeyword(e.target.value)}
            />
            <Button onClick={() => loadStores()}>조회</Button>
          </div>
          {groupFilter === 'all' && (
            <ul className="group_pick_list">
              {groups
                .filter(
                  (group) =>
                    !groupSearch.trim() ||
                    String(group.groupName || '').includes(groupSearch.trim()),
                )
                .map((group) => (
                  <li key={group.groupId}>
                    <button type="button" onClick={() => setGroupFilter(String(group.groupId))}>
                      {group.groupName}
                    </button>
                  </li>
                ))}
            </ul>
          )}
          <ul className="store_admin_list">
            {visibleStores.map((store) => (
              <li key={store.storeId}>
                <button type="button" onClick={() => openStore(store.storeId)}>
                  {store.storeId} {store.storeName}
                </button>
              </li>
            ))}
          </ul>
        </>
      )}

      {tab === 'list' && detail && (
        <section className="store_detail">
          <div className="detail_switch">
            <button type="button" className="back_list" onClick={() => setDetail(null)}>
              목록으로
            </button>
            <StorePickButton
              label={`${detail.store.storeId} ${detail.store.storeName}`}
              selectedId={detail.store.storeId}
              stores={stores.map((store) => ({
                storeId: store.storeId,
                storeName: `${store.storeId} ${store.storeName}`,
              }))}
              onSelect={(storeId) => openStore(storeId)}
            />
            <Form.Control value={name} onChange={(e) => setName(e.target.value)} />
            <Button
              onClick={async () => {
                try {
                  await patchStoreName(detail.store.storeId, name);
                  setMessage('지점명을 저장했습니다.');
                  openStore(detail.store.storeId);
                } catch (error) {
                  err(error, '지점명 변경 실패');
                }
              }}
            >
              지점명 변경
            </Button>
          </div>
          <div className="field_row">
            <Form.Control value={biz} onChange={(e) => setBiz(e.target.value)} />
            <Button
              onClick={async () => {
                try {
                  await patchBusinessNum(detail.store.storeId, biz);
                  setMessage('사업자번호를 저장했습니다.');
                  openStore(detail.store.storeId);
                } catch (error) {
                  err(error, '사업자번호 변경 실패');
                }
              }}
            >
              사업자번호 변경
            </Button>
          </div>
          <h4>관리자</h4>
          <ul className="manager_list">
            {(detail.managers || []).map((manager: any) => (
              <li key={`${manager.userId}-${manager.authority}`}>
                {manager.loginId} {manager.name} {manager.authority}
                <Button
                  onClick={() =>
                    setResetTarget({
                      userId: manager.userId,
                      loginId: manager.loginId,
                      name: manager.name || '',
                    })
                  }
                >
                  비밀번호 초기화
                </Button>
              </li>
            ))}
          </ul>
          {isMaster && (
            <div className="field_row manager_assign">
              <Form.Control placeholder="그룹 관리자로 배정할 아이디" id="group_manager_login" />
              <Form.Select
                value={managerGroupId}
                onChange={(e) => setManagerGroupId(e.target.value)}
                aria-label="그룹 관리자 그룹"
              >
                <option value="">그룹 선택</option>
                {groups.map((group) => (
                  <option key={group.groupId} value={group.groupId}>
                    {group.groupName}
                  </option>
                ))}
              </Form.Select>
              <Button
                onClick={async () => {
                  const input = document.getElementById(
                    'group_manager_login',
                  ) as HTMLInputElement | null;
                  const loginId = input?.value.trim() || '';
                  if (!loginId || !managerGroupId) {
                    setMessage('아이디와 그룹을 선택하세요.');
                    return;
                  }
                  try {
                    await assignGroupManager(Number(managerGroupId), loginId);
                    setMessage('그룹 관리자로 배정했습니다. 로그인하면 그 그룹 지점만 보입니다.');
                  } catch (error) {
                    err(error, '그룹 관리자 배정 실패');
                  }
                }}
              >
                그룹 관리자로 배정
              </Button>
            </div>
          )}
          <h4>단말기 분리</h4>
          <p className="info_text">
            이 체크는 단말기를 다른 지점으로 옮길 때만 씁니다. 그룹 배정은 그룹관리의 지점 목록에서
            합니다.
          </p>
          <ul className="device_move_list">
            {(detail.devices || []).map((device: any) => (
              <li key={device.deviceId}>
                <label>
                  <input
                    type="checkbox"
                    checked={picked.includes(device.deviceId)}
                    onChange={(e) =>
                      setPicked((prev) =>
                        e.target.checked
                          ? [...prev, device.deviceId]
                          : prev.filter((id) => id !== device.deviceId),
                      )
                    }
                  />
                  {device.deviceAlias} {device.catId}
                </label>
              </li>
            ))}
          </ul>
          <div className="input_form flex">
            <Form.Control
              value={targetStore}
              placeholder="옮길 지점코드"
              onChange={(e) => setTargetStore(e.target.value)}
            />
            <Button
              onClick={async () => {
                try {
                  await moveStoreDevices(detail.store.storeId, Number(targetStore), picked);
                  setMessage('단말기를 분리했습니다.');
                  openStore(detail.store.storeId);
                } catch (error) {
                  err(error, '단말기 분리 실패');
                }
              }}
            >
              선택 단말기 분리
            </Button>
          </div>
          <h4>처리 기록</h4>
          <ul>
            {(detail.audits || []).map((audit: any) => (
              <li key={audit.auditId}>
                {audit.createdDate} {audit.actorLoginId} {audit.action} {audit.beforeValue} →{' '}
                {audit.afterValue}
              </li>
            ))}
          </ul>
        </section>
      )}

      {tab === 'register' && registerSub === 'bulk' && (
        <section className="bulk_enroll">
          <p className="info_text">
            양식: 지점코드, 단말기 별칭, 단말기ID. 파일을 올리면 목록이 나오고, 등록하면 저장됩니다.
          </p>
          <input
            type="file"
            accept=".xlsx"
            onChange={async (e) => {
              const next = e.target.files?.[0] || null;
              setFile(next);
              setPreview([]);
              if (!next) return;
              try {
                setPreview(await previewDeviceExcel(next));
              } catch (error) {
                err(error, '목록 조회 실패');
              }
            }}
          />
          {preview.length > 0 && (
            <table className="bulk_preview">
              <thead>
                <tr>
                  <th>지점코드</th>
                  <th>단말기 별칭</th>
                  <th>단말기ID</th>
                </tr>
              </thead>
              <tbody>
                {preview.map((row) => (
                  <tr key={`${row.storeId}-${row.catId}`}>
                    <td>{row.storeId}</td>
                    <td>{row.deviceAlias}</td>
                    <td>{row.catId}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
          <Button
            disabled={!file || preview.length === 0}
            onClick={async () => {
              if (!file || preview.length === 0) return;
              try {
                const result = await saveDeviceExcel(file);
                setMessage(`등록 ${result.enrolled}건, 건너뜀 ${result.skipped}건`);
                setLogs(await getDeviceExcelLogs());
                setPreview([]);
                setFile(null);
              } catch (error) {
                err(error, '일괄등록 실패');
              }
            }}
          >
            등록
          </Button>
          <h4>등록 기록</h4>
          {logs.length === 0 && <p className="info_text">등록 이력이 없습니다.</p>}
          {logs.map((log) => (
            <div key={log.bulkId} className="bulk_log">
              <p>
                {log.createdDate} {log.actorLoginId} {log.fileName} 요청 {log.rowCount}건 / 등록{' '}
                {log.enrolled}건
              </p>
              {(log.items || []).length > 0 && (
                <table className="bulk_preview">
                  <thead>
                    <tr>
                      <th>지점코드</th>
                      <th>단말기 별칭</th>
                      <th>단말기ID</th>
                      <th>결과</th>
                    </tr>
                  </thead>
                  <tbody>
                    {log.items.map((item: any) => (
                      <tr key={`${log.bulkId}-${item.catId}`}>
                        <td>{item.storeId}</td>
                        <td>{item.deviceAlias}</td>
                        <td>{item.catId}</td>
                        <td>{item.result}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          ))}
        </section>
      )}

      {tab === 'grant' && (
        <section>
          <div className="input_form flex">
            <Form.Control
              placeholder="로그인 아이디"
              value={grantId}
              onChange={(e) => setGrantId(e.target.value)}
            />
            <label>
              <input
                type="checkbox"
                checked={perm.canRead}
                onChange={(e) => setPerm({ ...perm, canRead: e.target.checked })}
              />
              조회
            </label>
            <label>
              <input
                type="checkbox"
                checked={perm.canUpdate}
                onChange={(e) => setPerm({ ...perm, canUpdate: e.target.checked })}
              />
              수정
            </label>
            <label>
              <input
                type="checkbox"
                checked={perm.canDelete}
                onChange={(e) => setPerm({ ...perm, canDelete: e.target.checked })}
              />
              삭제
            </label>
            <Button
              onClick={async () => {
                try {
                  await saveStoreAdminPermission({ loginId: grantId, ...perm });
                  setPermissions(await getStoreAdminPermissions());
                  setMessage('상점관리 권한을 저장했습니다.');
                } catch (error) {
                  err(error, '권한 저장 실패');
                }
              }}
            >
              부여
            </Button>
          </div>
          <ul>
            {permissions.map((row) => (
              <li key={row.userId}>
                {row.loginId} {row.name} 조회 {row.canRead ? 'Y' : 'N'} 수정{' '}
                {row.canUpdate ? 'Y' : 'N'} 삭제 {row.canDelete ? 'Y' : 'N'}
              </li>
            ))}
          </ul>
        </section>
      )}

      {tab === 'group' && openGroupId == null && (
        <section className="group_panel">
          <div className="field_row">
            <Form.Control
              placeholder="그룹명"
              value={groupName}
              onChange={(e) => setGroupName(e.target.value)}
            />
            <Button
              onClick={async () => {
                if (!groupName.trim()) {
                  setMessage('그룹명을 입력하세요.');
                  return;
                }
                try {
                  await createStoreGroup(groupName.trim());
                  setGroupName('');
                  setGroups(await getStoreGroups());
                  setMessage('그룹을 등록했습니다.');
                } catch (error) {
                  err(error, '그룹 생성 실패');
                }
              }}
            >
              그룹 추가
            </Button>
          </div>
          <Form.Control
            placeholder="그룹 검색"
            value={groupSearch}
            onChange={(e) => setGroupSearch(e.target.value)}
          />
          <ul className="group_list">
            {groups
              .filter(
                (group) =>
                  !groupSearch.trim() || String(group.groupName || '').includes(groupSearch.trim()),
              )
              .map((group) => (
                <li key={group.groupId} className="group_row">
                  {renameId === group.groupId ? (
                    <Form.Control
                      value={renameName}
                      onChange={(e) => setRenameName(e.target.value)}
                      aria-label="그룹명 수정"
                    />
                  ) : (
                    <button
                      type="button"
                      className="group_name"
                      onClick={() => setOpenGroupId(group.groupId)}
                    >
                      {group.groupName}
                      {group.managerLoginId ? ` · ${group.managerLoginId}` : ''}
                    </button>
                  )}
                  <div className="group_actions">
                    {renameId === group.groupId ? (
                      <Button
                        onClick={async () => {
                          if (!renameName.trim()) {
                            setMessage('그룹명을 입력하세요.');
                            return;
                          }
                          try {
                            await renameStoreGroup(group.groupId, renameName.trim());
                            setRenameId(null);
                            setGroups(await getStoreGroups());
                            setMessage('그룹명을 수정했습니다.');
                          } catch (error) {
                            err(error, '그룹 수정 실패');
                          }
                        }}
                      >
                        저장
                      </Button>
                    ) : (
                      <Button
                        onClick={() => {
                          setRenameId(group.groupId);
                          setRenameName(group.groupName || '');
                        }}
                      >
                        수정
                      </Button>
                    )}
                    <Button
                      onClick={async () => {
                        if (
                          !window.confirm(
                            `${group.groupName} 그룹을 삭제할까요? 이 그룹의 지점·관리자 배정만 정리됩니다.`,
                          )
                        )
                          return;
                        try {
                          await deleteStoreGroup(group.groupId);
                          if (openGroupId === group.groupId) setOpenGroupId(null);
                          setGroups(await getStoreGroups());
                          setMessage('그룹을 삭제했습니다.');
                        } catch (error) {
                          err(error, '그룹 삭제 실패');
                        }
                      }}
                    >
                      삭제
                    </Button>
                  </div>
                </li>
              ))}
          </ul>
          {groups.length === 0 && <p className="info_text">등록된 그룹이 없습니다.</p>}
        </section>
      )}

      {tab === 'group' && openGroupId != null && (
        <section className="group_panel">
          <div className="field_row">
            <Button variant="outline-dark" onClick={() => setOpenGroupId(null)}>
              목록
            </Button>
            <strong>{groups.find((group) => group.groupId === openGroupId)?.groupName}</strong>
          </div>
          <p className="info_text">
            관리자 {groups.find((group) => group.groupId === openGroupId)?.managerLoginId || '없음'}{' '}
            · 지점 {groups.find((group) => group.groupId === openGroupId)?.storeIds || '없음'}
          </p>
          <h3>지점 배정</h3>
          <div className="group_move_bar">
            <span>선택 {checkedStores.length}곳</span>
            <Button
              onClick={async () => {
                if (checkedStores.length === 0) {
                  setMessage('배정할 상점을 선택하세요.');
                  return;
                }
                try {
                  await assignStoresToGroup(openGroupId, checkedStores);
                  setCheckedStores([]);
                  setGroups(await getStoreGroups());
                  setMessage('이 그룹에 지점을 배정했습니다.');
                } catch (error) {
                  err(error, '그룹 배정 실패');
                }
              }}
            >
              그룹 배정
            </Button>
            <Button
              onClick={async () => {
                if (checkedStores.length === 0) {
                  setMessage('해제할 상점을 선택하세요.');
                  return;
                }
                try {
                  await unassignStoresFromGroup(openGroupId, checkedStores);
                  setCheckedStores([]);
                  setGroups(await getStoreGroups());
                  setMessage('이 그룹에서만 상점을 뺐습니다.');
                } catch (error) {
                  err(error, '그룹 해제 실패');
                }
              }}
            >
              이 그룹에서 해제
            </Button>
          </div>
          <Form.Control
            placeholder="지점코드 또는 지점명"
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
          />
          <ul className="store_admin_list">
            {assignStores
              .filter((store) => {
                const mine = storeIdSet(
                  groups.find((group) => group.groupId === openGroupId)?.storeIds,
                ).has(store.storeId);
                return mine || keyword.trim().length > 0;
              })
              .slice(0, 40)
              .map((store) => (
                <li key={store.storeId}>
                  <label>
                    <input
                      type="checkbox"
                      checked={checkedStores.includes(store.storeId)}
                      onChange={(e) =>
                        setCheckedStores((prev) =>
                          e.target.checked
                            ? [...prev, store.storeId]
                            : prev.filter((id) => id !== store.storeId),
                        )
                      }
                    />
                    {store.storeId} {store.storeName}
                    {storeIdSet(
                      groups.find((group) => group.groupId === openGroupId)?.storeIds,
                    ).has(store.storeId)
                      ? ' · 배정됨'
                      : ''}
                  </label>
                </li>
              ))}
          </ul>
          <h3>관리자 배정</h3>
          <Form.Control
            placeholder="회원 아이디 검색"
            value={memberQuery}
            onChange={(e) => setMemberQuery(e.target.value)}
          />
          <ul className="store_admin_list">
            {members.map((member) => {
              const phone = String(member.phoneNumber || member.phone_number || '');
              const masked = phone.length >= 7 ? `${phone.slice(0, 3)}-****-****` : '';
              const loginId = member.loginId || member.login_id;
              const auth = String(member.authority || '');
              const role = auth.includes('MANAGER')
                ? '매니저'
                : auth.includes('ADMIN')
                  ? '관리자'
                  : '회원';
              return (
                <li key={`${loginId}-${auth}`}>
                  <label>
                    <input
                      type="checkbox"
                      checked={pickedMembers.includes(loginId)}
                      onChange={(e) =>
                        setPickedMembers((prev) =>
                          e.target.checked
                            ? [...prev, loginId]
                            : prev.filter((id) => id !== loginId),
                        )
                      }
                    />
                    {loginId} {masked} {role}
                  </label>
                </li>
              );
            })}
          </ul>
          <Button
            onClick={async () => {
              if (pickedMembers.length === 0) {
                setMessage('배정할 회원을 선택하세요.');
                return;
              }
              try {
                await assignGroupManagers(openGroupId, pickedMembers);
                setPickedMembers([]);
                setGroups(await getStoreGroups());
                setMessage('선택한 회원을 이 그룹 관리자로 추가했습니다.');
              } catch (error) {
                err(error, '그룹 관리자 배정 실패');
              }
            }}
          >
            그룹 관리자 배정
          </Button>
        </section>
      )}

      <Modal show={!!resetTarget} onHide={() => setResetTarget(null)} centered>
        <Modal.Header closeButton>
          <Modal.Title>비밀번호 초기화</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {resetTarget && (
            <p>
              {resetTarget.loginId} {resetTarget.name} 계정의 비밀번호를 초기화합니다. 확인을 누르면
              임시 비밀번호가 발급되고, 이 창을 닫으면 다시 볼 수 없습니다.
            </p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-dark" onClick={() => setResetTarget(null)}>
            취소
          </Button>
          <Button
            onClick={async () => {
              if (!resetTarget || !detail) return;
              try {
                const info = await resetStorePassword(detail.store.storeId, resetTarget.userId);
                setResetTarget(null);
                setResetInfo(info);
              } catch (error) {
                err(error, '비밀번호 초기화 실패');
              }
            }}
          >
            확인
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={!!resetInfo} onHide={() => setResetInfo(null)} centered>
        <Modal.Header closeButton>
          <Modal.Title>비밀번호 초기화</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {resetInfo && (
            <>
              <p>
                {resetInfo.loginId} 계정은 초기 비밀번호 <strong>{resetInfo.tempPassword}</strong>{' '}
                로 로그인합니다.
              </p>
              <p>
                로그인 후 비밀번호를 다시 설정해야 합니다. 이 비밀번호는 이 창에서만 확인할 수
                있습니다.
              </p>
            </>
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default StoreManagement;
